import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { User } from '@homeviews/models'
export const AUTH_FEATURE_KEY = 'auth'
declare const window: any

type AuthState = {
  user: User | null
  token: string | null
  showUpgradeForm?: boolean
}

const initialAuthState: AuthState = {
  user: null,
  token: null,
  showUpgradeForm: false,
}

export const authSlice = createSlice({
  name: AUTH_FEATURE_KEY,
  initialState: initialAuthState,
  reducers: {
    setToken: (
      state,
      { payload: { token } }: PayloadAction<{ token: string }>,
    ) => {
      localStorage.setItem('homeviews_access_token', token)
      state.token = token
    },
    setUser: (state, { payload: { user } }: PayloadAction<{ user: User }>) => {
      state.user = user
      if (window.homeviewsMixpanel?.config?.token) {
        window.homeviewsMixpanel.identify(user.id)
        window.homeviewsMixpanel.people.set('email', user.email)
      }
    },
    logout: () => {
      localStorage.removeItem('homeviews_access_token')
      if (window.homeviewsMixpanel?.config?.token) {
        window.homeviewsMixpanel.reset()
      }
      return initialAuthState
    },
    toggleUpgradeForm: (
      state,
      { payload: { open } }: PayloadAction<{ open: boolean }>,
    ) => {
      if (open) {
      }
      state.showUpgradeForm = open
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const authReducer = authSlice.reducer

export const { setToken, setUser, logout, toggleUpgradeForm } =
  authSlice.actions

export const getAuthState = (rootState: unknown): AuthState =>
  rootState[AUTH_FEATURE_KEY]

export const getUser = (rootState: unknown): User =>
  rootState[AUTH_FEATURE_KEY]?.user as User

const EMPTY_DEVELOPERS = Object.freeze([]) as NonNullable<User['developers']>

export const getDevelopers = (
  rootState: unknown,
): NonNullable<User['developers']> =>
  rootState[AUTH_FEATURE_KEY]?.user?.developers ?? EMPTY_DEVELOPERS

export const getUpgradeFormState = (rootState: unknown): boolean =>
  rootState[AUTH_FEATURE_KEY]?.showUpgradeForm

export const isPremiumDeveloperUser = (rootState: unknown): boolean =>
  rootState[AUTH_FEATURE_KEY]?.user?.premium
export const isStandardDeveloperUser = (rootState: unknown): boolean =>
  !rootState[AUTH_FEATURE_KEY]?.user?.premium
export const isEngageUser = (rootState: unknown): boolean =>
  rootState[AUTH_FEATURE_KEY]?.user?.engage
